<template>
  <div>
    <info :infos="[
        {label:'ID',value:vo.id},
        {label:'姓名',value:vo.name},
        {label:'身份证号',value:vo.idNumber},
        {label:'手机号',value:vo.phone},
        {label:'个性签名',value:vo.title},
        {label:'注册地址',value:utils.array.joinArrToStr([vo.addressProvince,vo.addressCity],'-')},
        {label:'个人介绍',value:vo.desc},
        {label:'审核状态',value:vo.examine},
        {label:'学历',value:vo.educationLevelText || '无'},
        {label:'毕业学校',value:vo.school || '无'},
        {label:'籍贯',value:vo.nativePlaceProvince ? (vo.nativePlaceProvince + ' '+vo.nativePlaceCity): '无'}
    ]"></info>

    <div class="title">资质材料</div>
    <div class="imgs">
      <div class="img-item" v-for="(img,index) in vo.imgs" :key="index">
        <cloud-img :url="img.url" :img-width="100" :img-height="100" :border-radius="6" :click-view="true"></cloud-img>
        <div class="info-text">{{ img.certName }}</div>
      </div>
    </div>

  </div>
</template>

<script>

import {miuTeacher} from "@/api/miu/teacher";
import Info from "@/components/system/Info.vue";
import CloudImg from "@/components/base/layout/img/CloudImg.vue";
import {utils} from "@/util/utils";

export default {
  name: 'TeacherDetail',
  computed: {
    utils() {
      return utils
    }
  },
  components: {
    CloudImg,
    Info
  },

  props: {
    id: Number,
  },

  data() {
    return {
      vo: {},
    }
  },

  created() {
    this.getData();
  },

  methods: {
    getData() {
      miuTeacher.detail(this.id).then(res => {
        this.vo = res.data;
      })

    },
  }


};
</script>

<style scoped>
.title {
  font-size: 18px;
  font-weight: bold;

  margin-top: 18px;
}

.imgs {
  margin: 12px auto;

  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  flex-flow: row;
}
</style>
